import { REGISTRATION_CONFIG, REGISTRATION_CONFIG_SUCCESS, REGISTRATION_CONFIG_ERROR, REGISTRATION_CONFIG_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RegistrationConfig = (state = initialState, action) => {
  switch (action.type) {
    case REGISTRATION_CONFIG:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case REGISTRATION_CONFIG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case REGISTRATION_CONFIG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case REGISTRATION_CONFIG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RegistrationConfig;
